import { render, staticRenderFns } from "./billing-dashboard.html?vue&type=template&id=35890166&scoped=true&"
import script from "./billing-dashboard.ts?vue&type=script&lang=js&"
export * from "./billing-dashboard.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35890166",
  null
  
)

export default component.exports